import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkUpdateIcd10Code } from '../types';

// @ts-ignore
const onUpdateIcd10Code: IThunkUpdateIcd10Code = thunk(async ({ updateIcd10Code }, payload) => {
  const icd10Code = await api.icd10Codes.update(payload).then(res => res.data);
  updateIcd10Code(icd10Code);
});

export default onUpdateIcd10Code;
